import { useInternalEditorState } from "@circle-react-shared/uikit/TipTap/internalEditorState";
import { defer } from "lodash";
import { useImperativeHandle } from "react";

export const useKeyboardHandler = ({
  selectedIndex,
  setSelectedIndex,
  items,
  ref,
  selectItem,
}: any) => {
  const { setPopupsVisible } = useInternalEditorState();
  useImperativeHandle(ref, () => {
    const upHandler = () =>
      setSelectedIndex(
        (Number(selectedIndex) + Number(items.length) - 1) % items.length,
      );

    const downHandler = () =>
      setSelectedIndex((Number(selectedIndex) + 1) % items.length);

    const enterHandler = () => selectItem(selectedIndex);

    const stopEvent = (event: KeyboardEvent) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return {
      onKeyDown: ({ event }: { event: KeyboardEvent }) => {
        switch (event.key) {
          case "ArrowUp":
            upHandler();
            return true;
          case "ArrowDown":
            downHandler();
            return true;
          case "Enter":
            if (!items.length) return false;
            enterHandler();
            stopEvent(event);
            defer(() => setPopupsVisible(false));
            return true;
          default:
            setPopupsVisible(false);
            return false;
        }
      },
    };
  }, [items, selectedIndex, selectItem, setPopupsVisible, setSelectedIndex]);
};
